import { styled } from '../../../../Styles/stitches.config'

export const ReadMore = styled('span', {
    cursor: 'pointer',
    fontWeight: 600,
    pl: '$2',
    textDecoration: 'underline',
})

export const StyledDescription = styled('div', {
    maxW: 500,
})
